var map = {
	"./aaveg_logo.jpeg": 94,
	"./akshara_nitt_logo.jpeg": 95,
	"./aws_logo.png": 96,
	"./contact_me.jpg": 97,
	"./corey_logo.png": 98,
	"./data_science_image.jpg": 33,
	"./deeplearning_ai_logo.png": 99,
	"./experience_logo.jpg": 36,
	"./full_stack_image.jpg": 34,
	"./gcp_logo.png": 100,
	"./maximus_logo.jpeg": 101,
	"./micro_services_image.jpg": 35,
	"./nit_trichy_logo.png": 102,
	"./opening.gif": 103,
	"./pragyan_logo.png": 104,
	"./projects_image.svg": 105,
	"./rotaract_logo.png": 106,
	"./sahithi_image.jpg": 30,
	"./scb_logo.png": 107,
	"./stanford_logo.png": 108,
	"./ub_logo.png": 109,
	"./ww.png": 37
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;